import { MouseEvent, useRef, useLayoutEffect, useState } from 'react';
import cn from 'clsx';
import { apiClasses, dataTestIds } from './definitions';
import { OptionPropsType } from './types';
import { useOptionStyles } from './styles';

const Option: React.FC<OptionPropsType> = ({
    label,
    value,
    selected,
    onSelected,
    onClick = () => {},
}) => {
    const classes = useOptionStyles();
    const elementRef = useRef<HTMLDivElement>(null);
    const [wasSelected, setWasSelected] = useState(false);

    useLayoutEffect(() => {
        if (selected && !wasSelected) {
            setTimeout(() => {
                // wait a bit to let the parent component render itself and measure its width correctly
                // note that useLayoutEffect does not fully solve the incorrect offset issue,
                // hence the usage of setTimeout()
                if (elementRef.current) {
                    onSelected(elementRef.current.offsetLeft, elementRef.current.offsetWidth);
                }
            }, 50);
        }
        setWasSelected(selected);
    }, [selected, onSelected, wasSelected]);

    const selectOnClick = (event: MouseEvent) => {
        if (!selected) {
            onClick(value, label, event);
        }
    };

    return (
        <div
            ref={elementRef}
            role="option"
            aria-selected={selected}
            data-class={selected ? apiClasses.dayOptionSelected : apiClasses.dayOption}
            data-testid={dataTestIds.dayOption}
            className={classes.option}
            onClick={selectOnClick}
            tabIndex={-1}
        >
            <span className={cn(classes.label, selected && classes.labelSelected)}>{label}</span>
        </div>
    );
};

export default Option;
